import "core-js/modules/es.array.reverse.js";
var _class, _WebMapServiceUrlStratum, _class2, _WebMapServiceCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
// Problems in current architecture:
// 1. After loading, can't tell what user actually set versus what came from e.g. GetCapabilities.
//  Solution: layering
// 2. CkanCatalogItem producing a WebMapServiceCatalogItem on load
// 3. Observable spaghetti
//  Solution: think in terms of pipelines with computed observables, document patterns.
// 4. All code for all catalog item types needs to be loaded before we can do anything.

import i18next from "i18next";
import { computed, makeObservable, override, runInAction } from "mobx";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import GeographicProjection from "terriajs-cesium/Source/Core/GeographicProjection";
import GeographicTilingScheme from "terriajs-cesium/Source/Core/GeographicTilingScheme";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import combine from "terriajs-cesium/Source/Core/combine";
import GetFeatureInfoFormat from "terriajs-cesium/Source/Scene/GetFeatureInfoFormat";
import ImageryLayerFeatureInfo from "terriajs-cesium/Source/Scene/ImageryLayerFeatureInfo";
import WebMapServiceImageryProvider from "terriajs-cesium/Source/Scene/WebMapServiceImageryProvider";
import URI from "urijs";
import TerriaError from "../../../Core/TerriaError";
import createTransformerAllowUndefined from "../../../Core/createTransformerAllowUndefined";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin, { getName } from "../../../ModelMixins/CatalogMemberMixin";
import DiffableMixin, { DiffStratum } from "../../../ModelMixins/DiffableMixin";
import ExportWebCoverageServiceMixin from "../../../ModelMixins/ExportWebCoverageServiceMixin";
import GetCapabilitiesMixin from "../../../ModelMixins/GetCapabilitiesMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import MinMaxLevelMixin from "../../../ModelMixins/MinMaxLevelMixin";
import TileErrorHandlerMixin from "../../../ModelMixins/TileErrorHandlerMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import { csvFeatureInfoContext } from "../../../Table/tableFeatureInfoContext";
import WebMapServiceCatalogItemTraits, { SUPPORTED_CRS_3857, SUPPORTED_CRS_4326 } from "../../../Traits/TraitsClasses/WebMapServiceCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import WebMapServiceCapabilitiesStratum from "./WebMapServiceCapabilitiesStratum";
// Remove problematic query parameters from URLs (GetCapabilities, GetMap, ...) - these are handled separately
const QUERY_PARAMETERS_TO_REMOVE = ["request", "service", "x", "y", "width", "height", "bbox", "layers", "styles", "version", "format", "srs", "crs"];

/** This LoadableStratum is responsible for setting WMS version based on CatalogItem.url */
export let WebMapServiceUrlStratum = (_class = (_WebMapServiceUrlStratum = class WebMapServiceUrlStratum extends LoadableStratum(WebMapServiceCatalogItemTraits) {
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new WebMapServiceUrlStratum(model);
  }
  get useWmsVersion130() {
    var _this$catalogItem$url, _this$catalogItem$url2;
    if ((_this$catalogItem$url = this.catalogItem.url) !== null && _this$catalogItem$url !== void 0 && _this$catalogItem$url.toLowerCase().includes("version=1.1.0") || (_this$catalogItem$url2 = this.catalogItem.url) !== null && _this$catalogItem$url2 !== void 0 && _this$catalogItem$url2.toLowerCase().includes("version=1.1.1")) {
      return false;
    }
  }
}, _defineProperty(_WebMapServiceUrlStratum, "stratumName", "wms-url-stratum"), _WebMapServiceUrlStratum), _applyDecoratedDescriptor(_class.prototype, "useWmsVersion130", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "useWmsVersion130"), _class.prototype), _class);

// Order is important so that the traits are overridden correctly
StratumOrder.addLoadStratum(WebMapServiceUrlStratum.stratumName);
StratumOrder.addLoadStratum(DiffStratum.stratumName);
let WebMapServiceCatalogItem = (_class2 = (_WebMapServiceCatalogItem = class WebMapServiceCatalogItem extends TileErrorHandlerMixin(ExportWebCoverageServiceMixin(DiffableMixin(MinMaxLevelMixin(GetCapabilitiesMixin(UrlMixin(MappableMixin(CatalogMemberMixin(CreateModel(WebMapServiceCatalogItemTraits))))))))) {
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    // hide elements in the info section which might show information about the datasource
    _defineProperty(this, "_sourceInfoItemNames", [i18next.t("models.webMapServiceCatalogItem.getCapabilitiesUrl")]);
    _defineProperty(this, "_webMapServiceCatalogGroup", undefined);
    _defineProperty(this, "_createImageryProvider", createTransformerAllowUndefined(time => {
      var _this$maximumShownFea, _this$styles, _this$styles2, _this$getMaximumLevel;
      // Don't show anything on the map until GetCapabilities finishes loading.
      if (this.isLoadingMetadata) {
        return undefined;
      }
      if (this.url === undefined) {
        return undefined;
      }
      console.log("Creating new ImageryProvider for time ".concat(time));

      // Set dimensionParameters
      const dimensionParameters = formatDimensionsForOws(this.dimensions);
      if (time !== undefined) {
        dimensionParameters.time = time;
      }

      // Construct parameters objects
      // We use slightly different parameters for GetMap and GetFeatureInfo requests
      const parameters = _objectSpread(_objectSpread(_objectSpread({}, this.useWmsVersion130 ? WebMapServiceCatalogItem.defaultParameters130 : WebMapServiceCatalogItem.defaultParameters111), this.parameters), dimensionParameters);
      const getFeatureInfoParameters = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.useWmsVersion130 ? WebMapServiceCatalogItem.defaultGetFeatureParameters130 : WebMapServiceCatalogItem.defaultGetFeatureParameters111), {}, {
        feature_count: 1 + ((_this$maximumShownFea = this.maximumShownFeatureInfos) !== null && _this$maximumShownFea !== void 0 ? _this$maximumShownFea : this.terria.configParameters.defaultMaximumShownFeatureInfos)
      }, this.parameters), dimensionParameters), this.getFeatureInfoParameters);
      if (this.supportsColorScaleRange) {
        parameters.COLORSCALERANGE = this.colorScaleRange;
      }

      // Styles parameter is mandatory (for GetMap and GetFeatureInfo requests), but can be empty string to use default style
      parameters.styles = (_this$styles = this.styles) !== null && _this$styles !== void 0 ? _this$styles : "";
      getFeatureInfoParameters.styles = (_this$styles2 = this.styles) !== null && _this$styles2 !== void 0 ? _this$styles2 : "";
      Object.assign(parameters, this.diffModeParameters);
      Object.assign(getFeatureInfoParameters, this.diffModeGetFeatureInfoParameters);

      // Remove problematic query parameters from URL - these are handled by the parameters objects

      const baseUrl = QUERY_PARAMETERS_TO_REMOVE.reduce((url, parameter) => url.removeQuery(parameter).removeQuery(parameter.toUpperCase()).removeQuery(parameter.toLowerCase()), new URI(this.url));

      // Set CRS for WMS 1.3.0
      // Set SRS for WMS 1.1.1
      const crs = this.useWmsVersion130 ? this.crs : undefined;
      const srs = this.useWmsVersion130 ? undefined : this.crs;
      const imageryOptions = {
        url: proxyCatalogItemUrl(this, baseUrl.toString()),
        layers: this.validLayers.length > 0 ? this.validLayers.join(",") : "",
        parameters,
        crs,
        srs,
        getFeatureInfoParameters,
        getFeatureInfoUrl: this.getFeatureInfoUrl,
        tileWidth: this.tileWidth,
        tileHeight: this.tileHeight,
        tilingScheme: this.tilingScheme,
        maximumLevel: (_this$getMaximumLevel = this.getMaximumLevel(true)) !== null && _this$getMaximumLevel !== void 0 ? _this$getMaximumLevel : this.maximumLevel,
        minimumLevel: this.minimumLevel,
        credit: this.attribution
        // Note: we set enablePickFeatures in _currentImageryParts and _nextImageryParts
      };
      imageryOptions.getFeatureInfoFormats = this.getFeatureInfoFormats;
      if (imageryOptions.maximumLevel !== undefined && this.hideLayerAfterMinScaleDenominator) {
        // Make Cesium request one extra level so we can tell the user what's happening and return a blank image.
        ++imageryOptions.maximumLevel;
      }
      const imageryProvider = new WebMapServiceImageryProvider(imageryOptions);
      return this.updateRequestImage(imageryProvider);
    }));
    makeObservable(this);
    this.strata.set(WebMapServiceUrlStratum.stratumName, new WebMapServiceUrlStratum(this));
  }
  get type() {
    return WebMapServiceCatalogItem.type;
  }
  get shortReport() {
    if (this.tilingScheme instanceof GeographicTilingScheme && this.terria.currentViewer.type === "Leaflet") {
      return i18next.t("map.cesium.notWebMercatorTilingScheme", this);
    }
    return super.shortReport;
  }
  get colorScaleRange() {
    if (this.supportsColorScaleRange) {
      return "".concat(this.colorScaleMinimum, ",").concat(this.colorScaleMaximum);
    }
    return undefined;
  }
  async createGetCapabilitiesStratumFromParent(capabilities) {
    const stratum = await WebMapServiceCapabilitiesStratum.load(this, capabilities);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  async forceLoadMapItems() {
    if (this.invalidLayers.length > 0) throw new TerriaError({
      sender: this,
      title: i18next.t("models.webMapServiceCatalogItem.noLayerFoundTitle"),
      message: i18next.t("models.webMapServiceCatalogItem.noLayerFoundMessage", {
        name: getName(this),
        layers: this.invalidLayers.join(", ")
      })
    });
  }
  async forceLoadMetadata() {
    if (this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName) !== undefined) return;
    const stratum = await WebMapServiceCapabilitiesStratum.load(this);
    runInAction(() => {
      this.strata.set(GetCapabilitiesMixin.getCapabilitiesStratumName, stratum);
    });
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "0d";
  }
  get layersArray() {
    if (Array.isArray(this.layers)) {
      return this.layers;
    } else if (this.layers) {
      return this.layers.split(",");
    } else {
      return [];
    }
  }

  /** LAYERS which are valid (i.e. exist in GetCapabilities).
   * These can be fetched from the server (eg GetMap request)
   */
  get validLayers() {
    const gcStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (gcStratum) return this.layersArray.map(layer => {
      var _gcStratum$capabiliti;
      return (_gcStratum$capabiliti = gcStratum.capabilities.findLayer(layer)) === null || _gcStratum$capabiliti === void 0 ? void 0 : _gcStratum$capabiliti.Name;
    }).filter(isDefined);
    return [];
  }

  /** LAYERS which are **INVALID** - they do **not** exist in GetCapabilities
   * These layers can **not** be fetched the server (eg GetMap request)
   */
  get invalidLayers() {
    const gcStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    if (gcStratum) return this.layersArray.filter(layer => {
      var _gcStratum$capabiliti2;
      return !isDefined((_gcStratum$capabiliti2 = gcStratum.capabilities.findLayer(layer)) === null || _gcStratum$capabiliti2 === void 0 ? void 0 : _gcStratum$capabiliti2.Name);
    });
    return [];
  }
  get stylesArray() {
    var _this$styles$split, _this$styles3;
    return (_this$styles$split = (_this$styles3 = this.styles) === null || _this$styles3 === void 0 ? void 0 : _this$styles3.split(",")) !== null && _this$styles$split !== void 0 ? _this$styles$split : [];
  }
  get discreteTimes() {
    const getCapabilitiesStratum = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName);
    return getCapabilitiesStratum === null || getCapabilitiesStratum === void 0 ? void 0 : getCapabilitiesStratum.discreteTimes;
  }
  get defaultGetCapabilitiesUrl() {
    if (this.uri) {
      const baseUrl = QUERY_PARAMETERS_TO_REMOVE.reduce((url, parameter) => url.removeQuery(parameter).removeQuery(parameter.toUpperCase()).removeQuery(parameter.toLowerCase()), this.uri.clone());
      return baseUrl.setSearch({
        service: "WMS",
        version: this.useWmsVersion130 ? "1.3.0" : "1.1.1",
        request: "GetCapabilities"
      }).toString();
    } else {
      return undefined;
    }
  }
  get canDiffImages() {
    const hasValidDiffStyles = this.availableDiffStyles.some(diffStyle => {
      var _this$styleSelectable;
      return (_this$styleSelectable = this.styleSelectableDimensions) === null || _this$styleSelectable === void 0 || (_this$styleSelectable = _this$styleSelectable[0]) === null || _this$styleSelectable === void 0 || (_this$styleSelectable = _this$styleSelectable.options) === null || _this$styleSelectable === void 0 ? void 0 : _this$styleSelectable.find(style => style.id === diffStyle);
    });
    return hasValidDiffStyles === true;
  }
  showDiffImage(firstDate, secondDate, diffStyleId) {
    if (this.canDiffImages === false) {
      return;
    }

    // A helper to get the diff tag given a date string
    const firstDateStr = this.getTagForTime(firstDate);
    const secondDateStr = this.getTagForTime(secondDate);
    this.setTrait(CommonStrata.user, "firstDiffDate", firstDateStr);
    this.setTrait(CommonStrata.user, "secondDiffDate", secondDateStr);
    this.setTrait(CommonStrata.user, "diffStyleId", diffStyleId);
    this.setTrait(CommonStrata.user, "isShowingDiff", true);
  }
  clearDiffImage() {
    this.setTrait(CommonStrata.user, "firstDiffDate", undefined);
    this.setTrait(CommonStrata.user, "secondDiffDate", undefined);
    this.setTrait(CommonStrata.user, "diffStyleId", undefined);
    this.setTrait(CommonStrata.user, "isShowingDiff", false);
  }
  getLegendBaseUrl() {
    // Remove problematic query parameters from URL
    const baseUrl = QUERY_PARAMETERS_TO_REMOVE.reduce((url, parameter) => url.removeQuery(parameter).removeQuery(parameter.toUpperCase()).removeQuery(parameter.toLowerCase()), new URI(this.url));
    return baseUrl.toString();
  }
  getLegendUrlForStyle(styleId, firstDate, secondDate) {
    var _this$availableStyles;
    const firstTag = firstDate && this.getTagForTime(firstDate);
    const secondTag = secondDate && this.getTagForTime(secondDate);
    const time = filterOutUndefined([firstTag, secondTag]).join(",");
    const layerName = (_this$availableStyles = this.availableStyles.find(style => style.styles.some(s => s.name === styleId))) === null || _this$availableStyles === void 0 ? void 0 : _this$availableStyles.layerName;
    const uri = URI("".concat(this.url, "?service=WMS&version=1.1.0&request=GetLegendGraphic&format=image/png&transparent=True")).addQuery("layer", encodeURIComponent(layerName || "")).addQuery("styles", encodeURIComponent(styleId));
    if (time) {
      uri.addQuery("time", time);
    }
    return uri.toString();
  }
  get mapItems() {
    // Don't return anything if there are invalid layers
    // See forceLoadMapItems for error message
    if (this.invalidLayers.length > 0) return [];
    if (this.isShowingDiff === true) {
      return this._diffImageryParts ? [this._diffImageryParts] : [];
    }
    const result = [];
    const current = this._currentImageryParts;
    if (current) {
      result.push(current);
    }
    const next = this._nextImageryParts;
    if (next) {
      result.push(next);
    }
    return result;
  }
  get tilingScheme() {
    if (this.crs) {
      if (SUPPORTED_CRS_3857.includes(this.crs)) return new WebMercatorTilingScheme();
      if (SUPPORTED_CRS_4326.includes(this.crs)) return new GeographicTilingScheme();
    }
    return new WebMercatorTilingScheme();
  }
  get _currentImageryParts() {
    const imageryProvider = this._createImageryProvider(this.currentDiscreteTimeTag);
    if (imageryProvider === undefined) {
      return undefined;
    }

    // Reset feature picking for the current imagery layer.
    // We disable feature picking for the next imagery layer.
    imageryProvider.enablePickFeatures = this.allowFeaturePicking;
    return {
      imageryProvider,
      alpha: this.opacity,
      show: this.show,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    };
  }
  get _nextImageryParts() {
    if (this.terria.timelineStack.contains(this) && !this.isPaused && this.nextDiscreteTimeTag) {
      const imageryProvider = this._createImageryProvider(this.nextDiscreteTimeTag);
      if (imageryProvider === undefined) {
        return undefined;
      }

      // Disable feature picking for the next imagery layer.
      imageryProvider.enablePickFeatures = false;
      return {
        imageryProvider,
        alpha: 0.0,
        show: true,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      };
    } else {
      return undefined;
    }
  }
  get _diffImageryParts() {
    const diffStyleId = this.diffStyleId;
    if (this.firstDiffDate === undefined || this.secondDiffDate === undefined || diffStyleId === undefined) {
      return;
    }
    const time = "".concat(this.firstDiffDate, ",").concat(this.secondDiffDate);
    const imageryProvider = this._createImageryProvider(time);
    if (imageryProvider) {
      return {
        imageryProvider,
        alpha: this.opacity,
        show: this.show,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      };
    }
    return undefined;
  }
  get diffModeParameters() {
    return this.isShowingDiff ? {
      styles: this.diffStyleId
    } : {};
  }
  get diffModeGetFeatureInfoParameters() {
    return this.isShowingDiff ? {
      styles: this.diffStyleId
    } : {};
  }
  getTagForTime(date) {
    var _this$discreteTimesAs;
    const index = this.getDiscreteTimeIndex(date);
    return index !== undefined ? (_this$discreteTimesAs = this.discreteTimesAsSortedJulianDates) === null || _this$discreteTimesAs === void 0 ? void 0 : _this$discreteTimesAs[index].tag : undefined;
  }
  get styleSelectableDimensions() {
    return this.availableStyles.map((layer, layerIndex) => {
      var _this$styles4;
      let name = "Styles";

      // If multiple layers -> prepend layer name to name
      if (this.availableStyles.length > 1) {
        var _capabilitiesLayers$g;
        // Attempt to get layer title from GetCapabilitiesStratum
        const layerTitle = layer.layerName && ((_capabilitiesLayers$g = this.strata.get(GetCapabilitiesMixin.getCapabilitiesStratumName).capabilitiesLayers.get(layer.layerName)) === null || _capabilitiesLayers$g === void 0 ? void 0 : _capabilitiesLayers$g.Title);
        name = "".concat(layerTitle || layer.layerName || "Layer ".concat(layerIndex + 1), " styles");
      }
      const options = filterOutUndefined(layer.styles.map(function (s) {
        if (isDefined(s.name)) {
          return {
            name: s.title || s.name || "",
            id: s.name
          };
        }
      }));

      // Try to set selectedId to value stored in `styles` trait for this `layerIndex`
      // The `styles` parameter is CSV, a style for each layer
      const selectedId = (_this$styles4 = this.styles) === null || _this$styles4 === void 0 || (_this$styles4 = _this$styles4.split(",")) === null || _this$styles4 === void 0 ? void 0 : _this$styles4[layerIndex];
      return {
        name,
        id: "".concat(this.uniqueId, "-").concat(layer.layerName, "-styles"),
        options,
        selectedId,
        setDimensionValue: (stratumId, newStyle) => {
          if (!newStyle) return;
          runInAction(() => {
            const styles = this.styleSelectableDimensions.map(style => style.selectedId || "");
            styles[layerIndex] = newStyle;
            this.setTrait(stratumId, "styles", styles.join(","));
          });
        },
        // There is no way of finding out default style if no style has been selected :(
        // To use the default style, we just send empty "styles" to WMS server
        // But if the server doesn't support GetLegendGraphic, then we can't request the default legend
        // Therefore - we only add the "Default style" / undefined option if supportsGetLegendGraphic is true
        allowUndefined: this.supportsGetLegendGraphic && options.length > 1,
        undefinedLabel: i18next.t("models.webMapServiceCatalogItem.defaultStyleLabel"),
        disable: this.isShowingDiff
      };
    });
  }
  get wmsDimensionSelectableDimensions() {
    const dimensions = [];

    // For each layer -> For each dimension
    this.availableDimensions.forEach(layer => {
      layer.dimensions.forEach(dim => {
        var _this$dimensions;
        // Only add dimensions if hasn't already been added (multiple layers may have the same dimension)
        if (!isDefined(dim.name) || dim.values.length < 2 || dimensions.findIndex(findDim => findDim.name === dim.name) !== -1) {
          return;
        }
        dimensions.push({
          name: dim.name,
          id: "".concat(this.uniqueId, "-").concat(dim.name),
          options: dim.values.map(value => {
            let name = value;
            // Add units and unitSybol if defined
            if (typeof dim.units === "string" && dim.units !== "") {
              if (typeof dim.unitSymbol === "string" && dim.unitSymbol !== "") {
                name = "".concat(value, " (").concat(dim.units, " ").concat(dim.unitSymbol, ")");
              } else {
                name = "".concat(value, " (").concat(dim.units, ")");
              }
            }
            return {
              name,
              id: value
            };
          }),
          // Set selectedId to value stored in `dimensions` trait, the default value, or the first available value
          selectedId: ((_this$dimensions = this.dimensions) === null || _this$dimensions === void 0 || (_this$dimensions = _this$dimensions[dim.name]) === null || _this$dimensions === void 0 ? void 0 : _this$dimensions.toString()) || dim.default || dim.values[0],
          setDimensionValue: (stratumId, newDimension) => {
            let newDimensions = {};
            newDimensions[dim.name] = newDimension;
            if (isDefined(this.dimensions)) {
              newDimensions = combine(newDimensions, this.dimensions);
            }
            runInAction(() => {
              this.setTrait(stratumId, "dimensions", newDimensions);
            });
          }
        });
      });
    });
    return dimensions;
  }
  get selectableDimensions() {
    if (this.disableDimensionSelectors) {
      return super.selectableDimensions;
    }
    return filterOutUndefined([...super.selectableDimensions, ...this.wmsDimensionSelectableDimensions, ...this.styleSelectableDimensions]);
  }

  /** If GetFeatureInfo/GetTimeseries request is returning CSV, we need to parse it into TimeSeriesFeatureInfoContext.
   */
  get featureInfoContext() {
    if (this.getFeatureInfoFormat.format !== "text/csv") return () => ({});
    return csvFeatureInfoContext(this);
  }
  get getFeatureInfoFormats() {
    const customFormat = this.getFeatureInfoFormat;
    if (customFormat) {
      if (customFormat.type === "json") {
        return [new GetFeatureInfoFormat("json", "application/json", json => geoJsonToFeatureInfoWithProject(json, this.tilingScheme.projection))];
      } else {
        return [new GetFeatureInfoFormat(customFormat.type, customFormat.format)];
      }
    }
    return [new GetFeatureInfoFormat("json", "application/json", json => geoJsonToFeatureInfoWithProject(json, this.tilingScheme.projection)), new GetFeatureInfoFormat("xml", "text/xml"), new GetFeatureInfoFormat("csv", "text/csv")];
  }
}, _defineProperty(_WebMapServiceCatalogItem, "abstractsToIgnore", ["A compliant implementation of WMS"]), _defineProperty(_WebMapServiceCatalogItem, "defaultParameters130", {
  transparent: true,
  format: "image/png",
  exceptions: "XML",
  styles: "",
  version: "1.3.0"
}), _defineProperty(_WebMapServiceCatalogItem, "defaultGetFeatureParameters130", {
  exceptions: "XML",
  version: "1.3.0"
}), _defineProperty(_WebMapServiceCatalogItem, "defaultParameters111", {
  transparent: true,
  format: "image/png",
  exceptions: "application/vnd.ogc.se_xml",
  styles: "",
  tiled: true,
  version: "1.1.1"
}), _defineProperty(_WebMapServiceCatalogItem, "defaultGetFeatureParameters111", {
  exceptions: "application/vnd.ogc.se_xml",
  version: "1.1.1"
}), _defineProperty(_WebMapServiceCatalogItem, "type", "wms"), _WebMapServiceCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "shortReport", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "shortReport"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "colorScaleRange", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "colorScaleRange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "layersArray", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "layersArray"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "validLayers", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "validLayers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "invalidLayers", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "invalidLayers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stylesArray", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "stylesArray"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "discreteTimes", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "discreteTimes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canDiffImages", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canDiffImages"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tilingScheme", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tilingScheme"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_currentImageryParts", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_currentImageryParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_nextImageryParts", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_nextImageryParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_diffImageryParts", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_diffImageryParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "diffModeParameters", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "diffModeParameters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "diffModeGetFeatureInfoParameters", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "diffModeGetFeatureInfoParameters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "styleSelectableDimensions", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styleSelectableDimensions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wmsDimensionSelectableDimensions", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wmsDimensionSelectableDimensions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectableDimensions", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "selectableDimensions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "featureInfoContext", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "featureInfoContext"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getFeatureInfoFormats", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "getFeatureInfoFormats"), _class2.prototype), _class2);
/**
 * Add `_dim` prefix to dimensions for OWS (WMS, WCS...) excluding time, styles and elevation
 */
export function formatDimensionsForOws(dimensions) {
  if (!isDefined(dimensions)) {
    return {};
  }
  return Object.entries(dimensions).reduce((formattedDimensions, _ref) =>
  // elevation is specified as simply "elevation", styles is specified as "styles"
  // Other (custom) dimensions are prefixed with 'dim_'.
  // See WMS 1.3.0 spec section C.3.2 and C.3.3.
  {
    let [key, value] = _ref;
    formattedDimensions[["time", "styles", "elevation"].includes(key === null || key === void 0 ? void 0 : key.toLowerCase()) ? key : "dim_".concat(key)] = value;
    return formattedDimensions;
  }, {});
}

// Take the GetFeatureInfo response and reproject the feature coordinates to geographic if necessary, so the position is correct when displayed on the map.
// Cesium [GetFeatureInfoFormat](https://github.com/CesiumGS/cesium/blob/5754031f65646bee5f9d0e9a56dec7d3677a8b08/packages/engine/Source/Scene/GetFeatureInfoFormat.js#L74) assumes picked features is returned in geographic projection, so we need to convert them when tile scheme is not geographic.
function geoJsonToFeatureInfoWithProject(json, projection) {
  const result = [];
  const features = json.features;
  for (let i = 0; i < features.length; ++i) {
    const feature = features[i];
    const featureInfo = new ImageryLayerFeatureInfo();
    featureInfo.data = feature;
    featureInfo.properties = feature.properties;
    featureInfo.configureNameFromProperties(feature.properties);
    featureInfo.configureDescriptionFromProperties(feature.properties);

    // If this is a point feature, use the coordinates of the point.
    if (!!feature.geometry && feature.geometry.type === "Point") {
      const x = feature.geometry.coordinates[0];
      const y = feature.geometry.coordinates[1];
      if (!projection || projection instanceof GeographicProjection) {
        featureInfo.position = Cartographic.fromDegrees(x, y);
      } else {
        const positionInMeters = new Cartesian3(x, y, 0);
        const cartographic = projection.unproject(positionInMeters);
        featureInfo.position = cartographic;
      }
    }
    result.push(featureInfo);
  }
  return result;
}
export default WebMapServiceCatalogItem;